import React from 'react';
import {TabView} from '../../../components/tab/TabView';
import {View} from '@unthinkable/react-core-components';
import {
  DripInmailActiveTable,
  DripInmailCompletedTable,
} from './DripInmailTable';
import {SearchFilter} from '../../../components/filter/Filters';
import {useFilter} from '../../../controllers/useFilter';

export const DripInmailTabView = props => {
  const {route: {params} = {}} = props;
  const {onChangeFilter, searchValue} = useFilter({});
  const tabs = {
    active: {
      label: 'Active',
      view: <DripInmailActiveTable searchValue={searchValue} />,
    },
    completed: {
      label: 'Completed',
      view: <DripInmailCompletedTable searchValue={searchValue} />,
    },
  };

  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
      ]}
    />
  );
};
